// extracted by mini-css-extract-plugin
export default {"attribute-options":"AttributeOptions_attribute-options__SZxHn"};